import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ffffff;
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const SubTitle = styled.p`
  font-size: 17px;
  color: #64748b;
  line-height: 1.7;

  @media (max-width: 768px) {
    font-size: 15px;
    br {
      display: none;
    }
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const Card = styled.div<{ $accent: string }>`
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${({ $accent }) => $accent};
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
    border-color: #cbd5e1;
  }
`;

const CardIcon = styled.div`
  font-size: 32px;
  margin-bottom: 16px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #f8fafc;
`;

const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 12px;
`;

const CardDescription = styled.p`
  font-size: 15px;
  color: #64748b;
  line-height: 1.7;
`;

const AboutSection = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <Header>
            <Title>About Following Moments</Title>
            <SubTitle>
              우리는 기술을 통해 사람들의 순간을 더욱 의미있게 만들고,
              <br />
              장소와 경험을 연결하여 새로운 가치를 창출합니다.
            </SubTitle>
          </Header>

          <CardsContainer>
            <Card $accent="linear-gradient(135deg, #3b82f6, #06b6d4)">
              <CardIcon>🎯</CardIcon>
              <CardTitle>우리의 미션</CardTitle>
              <CardDescription>
                장소를 중심으로 사람들을 연결하고, 모든 순간을 기록하며 공유할 수 있는
                플랫폼을 제공하여 더 풍요로운 경험을 만들어갑니다.
              </CardDescription>
            </Card>

            <Card $accent="linear-gradient(135deg, #8b5cf6, #ec4899)">
              <CardIcon>🚀</CardIcon>
              <CardTitle>우리의 비전</CardTitle>
              <CardDescription>
                위치 기반 소셜 네트워크의 선두주자로서, 전 세계 사람들이
                자신의 경험을 공유하고 새로운 장소를 발견하는 혁신적인 플랫폼을 구축합니다.
              </CardDescription>
            </Card>

            <Card $accent="linear-gradient(135deg, #f59e0b, #ef4444)">
              <CardIcon>💡</CardIcon>
              <CardTitle>우리의 접근</CardTitle>
              <CardDescription>
                사용자 중심의 디자인과 최신 기술을 결합하여 직관적이고
                매력적인 서비스를 제공하며, 지속적인 혁신을 추구합니다.
              </CardDescription>
            </Card>
          </CardsContainer>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default AboutSection;
